/**
 * @deprecated
 * @param {string} localName
 * @returns {boolean}
 */
export const isInjectable = (localName) => {
    // @ts-ignore
    return angular
        .element(document)
        .injector()
        .has(`${toCamel(localName)}Directive`);
};
/**
 * @param {string} str
 */
const toCamel = (str) => str.replace(/(-[a-z])/g, ($1) => $1.toUpperCase().replace("-", ""));
